
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/pay-by-bank-ux",
      function () {
        return require("private-next-pages/docs/auth/pay-by-bank-ux.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/pay-by-bank-ux"])
      });
    }
  